const addressPriorityOrder = ["Billing", "Factory", "Delivery", "Warehouse"];

const getBuyerDefaultAddress = (addressData) => {
  let defaultAddress = addressData.find((el) => el.set_default === 1);

  if (!defaultAddress) {
    for (const type of addressPriorityOrder) {
      defaultAddress = addressData.find((el) => el.type_name === type);
      if (defaultAddress) break; // stop at first match
    }
  }

  if (!defaultAddress) {
    defaultAddress = addressData[0]; // Fallback to the first address if no default is set
  }

  return defaultAddress;
};

export default getBuyerDefaultAddress;
